import { ThemedIcon } from "../../../components/utilities";
import styled from "styled-components";

const amberWarningThreshold = 182;

const CompletedReviewsTableRowColumn = styled.td`
    padding: 0.6rem !important;
    vertical-align: middle;
    width: ${({ width }) => width}%;
`;

const CompletedReviewTableStatusIconColumn = ({ width, reviewScore, size = "lg" }) => {

    var inner = null;

    if(reviewScore != null && reviewScore <= 366) inner = <ThemedIcon variant="success" icon="fa-circle-check" size={size} />;
    if(reviewScore != null && reviewScore > 366 && reviewScore < 365 + amberWarningThreshold) inner = <ThemedIcon variant="warning" icon="fa-circle-check" size={size} />;
    if(reviewScore != null && reviewScore > 366 + amberWarningThreshold) inner = <ThemedIcon variant="danger" icon="fa-circle-check" size={size} />;

    if(inner != null) {
        return (
            <CompletedReviewsTableRowColumn width={width} className="text-center">
                {inner}
            </CompletedReviewsTableRowColumn> 
         );
    }   

    return (
        <CompletedReviewsTableRowColumn width={width} className="text-center">
            <span>-</span>
        </CompletedReviewsTableRowColumn>
    );
};

export default CompletedReviewTableStatusIconColumn;